import { useEffect, useState } from "react";
import { Box, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Category } from "../model/Category";
import { getCategories } from "../service/CategoryService";
import { CategoryDataGrid } from "../components/CategoryDataGrid";

export default function CategoryList() {
  const [categories, setCategories] = useState<Category[]>([]);
  const navigate = useNavigate();
  const [deleteCategory, setDeleteCategory] = useState<boolean>(true);
  useEffect(() => {
    if (deleteCategory) {
      getCategories().then((categories) => setCategories([...categories]));
      setDeleteCategory(false);
    }
  }, [deleteCategory]);
  const handleClick = () => {
    navigate(`/category/create`);
  };
  return (
    <>
      <Box sx={{ textAlign: "right", m: 2 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleClick}
          className="ce"
        >
          Créer une catégorie
        </Button>
      </Box>
      <CategoryDataGrid
        categories={categories}
        setDeleteCategory={setDeleteCategory}
      />
    </>
  );
}
